module.exports = __webpack_public_path__ + "img/ch18_06_夕阳玩偶.df6613b3.jpg";